export default {"src":"/_next/static/media/gas.8fbfe32e.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};